import logo from './logo.svg';
import './App.css';
import React, { useState } from 'react';

import { Layout , Image, Flex, Select, Button, Input, message } from 'antd';
import { Divider, Typography } from 'antd';
import { BrowserRouter as Router, Route, useRoutes, Link, Routes, useLocation } from 'react-router-dom';

function Verify() {

  const { Header, Content, Footer } = Layout;
  const { Title, Paragraph, Text, Link } = Typography;

  const handleSubmit = () => {
    // if (!selectedValue) {
    //   setErrorSelect('请先选择一个充值金额');
    //   message.error('请先选择一个充值金额');
    //   return false;
    // }

    // if (!email) {
    //   setErrorEmail('请输入UID或用户名'); // 设置错误信息
    //   message.error('请输入UID或用户名'); // 弹出错误提示
    //   return false;
    // } else if(!phone){
    //   setErrorPhone('请输入手机号'); // 设置错误信息
    //   message.error('请输入手机号'); // 弹出错误提示
    //   return false;
    // } else {
    //   // 处理提交逻辑
    //   console.log('提交的值：', email,phone);
    //   message.success('提交成功！');
    //   // 清空输入
    //   setSelectedValue('');
    //   setEmail('');
    //   setPhone('');
      document.getElementById("form").submit();
    // }
  };

  // 使用 useLocation 钩子获取当前 URL 的 location 对象
  const location = useLocation();
  // 创建一个 URLSearchParams 实例来解析查询参数
  const queryParams = new URLSearchParams(location.search);
  const r = queryParams.get('r'); // 获取查询参数 'r'
  console.log(r);

  document.title = "优惠充值活动-验证支付状态";
  
  return (
    <Layout style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header style={{ backgroundColor: '#001529', color: '#fff', display: 'flex', alignItems: 'center' , justifyContent: 'flex-start', padding: '0 20px'}}>
        <Image width={25} src="https://cdn.splash.lifeano.cn/lifeano_logo.png" alt="Logo" style={{ borderRadius: '50%' }}/>
        <span style={{ margin: 0, marginLeft: '16px', color: '#fff', fontSize:'16px'}}>金币优惠充值活动</span>
      </Header>
      <Content style={{ display: 'flow', justifyContent: 'center', alignItems: 'center', flex: 1 , padding: '10px'}}>
        {/* <Flex gap="middle" vertical style={{ width: '200px' }}> */}
          <Typography>
            <Title>验证支付状态</Title>
            <Paragraph>
              请别离开，下一步验证支付状态
            </Paragraph>
            <Paragraph>
              如您已经支付成功，请点击下方按钮【验证支付状态】
            </Paragraph>
            <Paragraph>
              <Link href="https://work.weixin.qq.com/kfid/kfcef54d3112165a3a8" target="_blank" rel="noopener noreferrer">
                如有问题请及时咨询客服
              </Link>
            </Paragraph>
          </Typography>
          <Divider dashed />
          
          <form action="http://xjad.top:8080/stripe_verify_order_status" method="post" id='form'>
          <input type="hidden" value={r ? r : ""} name="r"/>
          <Button htmlType="button" type="default" style={{ backgroundColor:'#001529' , color:'#fff', size: 'large' ,width:'100%', marginTop:'10px' , height:'50px'}} onClick={handleSubmit} >我已付款，立即验证支付状态</Button>
          </form>
        {/* </Flex> */}
        {/* 添加更多内容以测试滚动效果 */}
      
      </Content>
      <Footer style={{ textAlign: 'center', backgroundColor: '#001529', color: '#fff' }}>
        版权所有 Lifeano © 2024
      </Footer>
    </Layout>
  );
}

export default Verify;